import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-job-titles',
  templateUrl: './edit-job-titles.component.html',
  styleUrls: ['./edit-job-titles.component.scss']
})
export class EditJobTitlesComponent implements OnInit {

  jobTitleId: string | null = null;
  
  // استخدم متغير واحد فقط
  jobTitle: any = {
    name_ar: '',
    name_en: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
     private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.jobTitleId = this.route.snapshot.paramMap.get('id');
    if (this.jobTitleId) {
      this.loadJobTitle(this.jobTitleId);
    }
  }

  loadJobTitle(id: string): void {
    this.apiService.getJobTitleById(id).subscribe({
      next: (res: any) => {
        console.log('API Response:', res);
        
        // تعبئة البيانات بشكل صحيح
        if (res && res.data) {
          this.jobTitle = {
            name: res.data.name || '',
            name_en: res.data.name_en || ''
          };
        } else if (res) {
          this.jobTitle = {
            name: res.name || '',
            name_en: res.name_en || ''
          };
        }
        
        console.log('Job Title Data:', this.jobTitle);
      },
      error: (err) => {
        console.error('Failed to load job title:', err);
        // this.toastr.error('Failed to load job title details');
      }
    });
  }

  // updateJobTitle(): void {
  //   if (!this.jobTitleId) {
  //     this.toastr.error('Job Title ID is missing');
  //     return;
  //   }

  //   // التحقق من الحقول المطلوبة
  //   if (!this.jobTitle.name_en || !this.jobTitle.name_ar) {
  //     this.toastr.error('Please fill all required fields');
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('name_en', this.jobTitle.name_en);
  //   formData.append('name_ar', this.jobTitle.name_ar);

  //   this.apiService.editJobTitle(this.jobTitleId, formData.toString()).subscribe({
  //     next: (response: any) => {
  //       this.toastr.success('Job title updated successfully');
  //       this.router.navigate(['/job-title']);
  //     },
  //     error: (error: any) => {
  //       console.error('Update failed:', error);
        
  //       // معالجة الأخطاء من السيرفر
  //       if (error.error && error.error.errors) {
  //         const errors = error.error.errors;
  //         Object.keys(errors).forEach(key => {
  //           this.toastr.error(errors[key][0]);
  //         });
  //       } else {
  //         this.toastr.error('Failed to update job title');
  //       }
  //     }
  //   });
  // }
updateJobTitle(): void {
  if (!this.jobTitleId) {
    this.toastr.error(this.translate.instant('MENU.DASHBOARD.job_title_id_missing'));
    return;
  }

  // Validate required fields
  const name_en = this.jobTitle.name_en?.trim();
  const name_ar = this.jobTitle.name_ar?.trim();

  if (!name_en || !name_ar) {
    this.toastr.error(this.translate.instant('MENU.DASHBOARD.fill_required_fields'));
    return;
  }

  // Build query parameters
  const params = new URLSearchParams();
  params.append('name_en', name_en);
  params.append('name_ar', name_ar);

  this.apiService.editJobTitle(this.jobTitleId, params.toString()).subscribe({
    next: (response: any) => {
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.job_title_updated_successfully'));
      this.router.navigate(['/job-title']);
    },
    error: (error: any) => {
      console.error('Update failed:', error);

      if (error.error && error.error.errors) {
        const errors = error.error.errors;
        Object.keys(errors).forEach(key => {
          this.toastr.error(errors[key][0]);
        });
      } else {
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_update_job_title'));
      }
    }
  });
}

  cancel(): void {
    this.router.navigate(['/job-title']);
  }


}
 
 
   

